import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import UserAuthenticationLoginRegister from "pages/user-authentication-login-register";
import ShoppingCart from "pages/shopping-cart";
import HomepageDashboard from "pages/homepage-dashboard";
import ProductCatalogCategoryBrowse from "pages/product-catalog-category-browse";
import ProductDetailPage from "pages/product-detail-page";
import CheckoutProcess from "pages/checkout-process";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<HomepageDashboard />} />
        <Route path="/user-authentication-login-register" element={<UserAuthenticationLoginRegister />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/homepage-dashboard" element={<HomepageDashboard />} />
        <Route path="/product-catalog-category-browse" element={<ProductCatalogCategoryBrowse />} />
        <Route path="/product-detail-page" element={<ProductDetailPage />} />
        <Route path="/checkout-process" element={<CheckoutProcess />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;